const currMonth = new Date().getMonth();
const currYear = new Date().getFullYear();

// GLOBAL DATA

export const colors = {
  yellow: "#fec800",
  gray: "#858383",
  white: "#fff",
};

// DASHBOARD CHART OPTIONS

export const chartOptions = {
  chart: {
    type: "bar",
  },
  plotOptions: {
    bar: {
      borderRadius: 10,
      dataLabels: {
        style: {
          fontSize: "12px",
          position: "top", // top, center, bottom
        },
      },
    },
    line: {
      dataLabels: {
        style: {
          fontSize: "8px",
        },
      },
    },
  },
  dataLabels: {
    enabled: true,
  },
  xaxis: {
    categories: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    position: "bottom",
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    crosshairs: {
      fill: {
        type: "gradient",
        gradient: {
          colorFrom: "#D8E3F0",
          colorTo: "#BED1E6",
          stops: [0, 100],
          opacityFrom: 0.4,
          opacityTo: 0.5,
        },
      },
    },
    tooltip: {
      enabled: true,
    },
  },
  yaxis: {
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    labels: {
      show: true,
    },
  },
};

// DASHBOARD DATA EXTRACTION FUNCTIONS

export const extractChartData = (items, selectedYear = currYear) => {
  const counts = new Array(12).fill(0);
  let currMonthTotal = 0,
    currYearTotal = 0;
  const years = new Set();

  items.forEach((item) => {
    if (item !== null) {
      const itemDate = new Date(item.createdAt);
      const itemMonth = itemDate.getMonth();
      const itemYear = itemDate.getFullYear();

      if (!years.has(itemYear)) {
        years.add(itemYear);
      }

      if (itemYear === selectedYear) {
        counts[itemMonth]++;
        if (itemMonth === currMonth) {
          currMonthTotal++;
        }
        currYearTotal++;
      }
    }
  });

  return { counts: counts, currMonthTotal, currYearTotal, years: [...years] };
};

export const extractUserData = (items) => {
  let primaryUsers = 0;
  let secondaryUsers = 0;

  items.forEach((item) => {
    if (item !== null) {
      if (item.is_primary) {
        primaryUsers++;
      } else {
        secondaryUsers++;
      }
    }
  });

  return [primaryUsers, secondaryUsers];
};
